import { Col, Input, Label, Row, Button } from "reactstrap"

/**
 * Shared filter panel for account list pages.
 *
 * Props:
 *   filters        – { date_from, date_to, ...any extra fields }
 *   onChange(key, value) – called when any field changes
 *   onReset()      – called when the Reset button is clicked
 *   children       – optional extra filter controls (dropdowns, etc.)
 */
const AccountFilterPanel = ({ filters = {}, onChange, onReset, children }) => {
  return (
    <Row className="g-2 align-items-end mb-3">
      <Col xs={12} sm={6} md={3}>
        <Label className="mb-1 small fw-semibold">Date From</Label>
        <Input
          type="date"
          bsSize="sm"
          value={filters.date_from || ""}
          onChange={e => onChange("date_from", e.target.value)}
        />
      </Col>

      <Col xs={12} sm={6} md={3}>
        <Label className="mb-1 small fw-semibold">Date To</Label>
        <Input
          type="date"
          bsSize="sm"
          value={filters.date_to || ""}
          onChange={e => onChange("date_to", e.target.value)}
        />
      </Col>

      {children}

      <Col xs="auto">
        <Button
          color="secondary"
          size="sm"
          outline
          onClick={onReset}
          disabled={Object.values(filters).every(v => !v)}
        >
          Reset Filters
        </Button>
      </Col>
    </Row>
  )
}

export default AccountFilterPanel
